import { Component, computed, input} from '@angular/core';
import { CommonModule } from '@angular/common';

type AvatarSize = 'small' | 'medium' | 'large';
type AvatarShape = 'circle' | 'square';

@Component({
  selector: 'lib-ribera-avatar-ui',
  imports: [CommonModule],
  templateUrl: './ribera-avatar-ui.html',
  styleUrl: './ribera-avatar-ui.scss',
})
export class RiberaAvatarUi {

  image = input<string | null>(null);
  size = input<AvatarSize>('medium');
  shape = input<AvatarShape>('circle');
  name = input<string>('');

  shapee = computed(() => this.shape());

  sizePx = computed(() => {
    switch (this.size()) {
      case 'small': return '32px';
      case 'large': return '64px';
      default: return '48px';
    }
  });

  initialName = computed(() => {
    if (!this.name()) return '';
    return this.name().charAt(0).toUpperCase();
  });

  colorBackground = computed(() => {
    const colors = ['#FFB6C1', '#ADD8E6', '#90EE90', '#FFD700', '#FFA07A'];
    if (!this.name()) return colors[0];
    const charCode = this.name().charCodeAt(0);
    return colors[charCode % colors.length];
  });

  sizeFont = computed(() => {
    switch (this.size()) {
      case 'small': return '1rem';
      case 'large': return '1.8rem';
      default: return '1.5rem';
    }
  });

}
